import React, { Fragment, useState } from "react";
import { Breadcrumbs } from "../../AbstractElements";
import {
  UpdatePassword,
  CurrentPassword,
  NewPassword,
  ConfirmPassword,
} from "../../Constant";
import { Form, FormGroup, Label, Row, Container, Col } from "reactstrap";
import { Btn, Image } from "../../AbstractElements";
import { useForm } from "react-hook-form";
import { changePassword } from "../../Services/Auth.service";
import { toast } from "react-toastify";
import { showAlert } from "../../Services/Shared.service";
const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [toggleOldPassword, setToggleOldPassword] = useState(false);
  const [toggleNewPassword, setToggleNewPassword] = useState(false);
  const [toggleConfirmPassword, setToggleConfirmPassword] = useState(false);
  const [changePasswordRes, setChangePasswordRes] = useState(() => {
    return {
      message: null,
      color: null,
    };
  });
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();
  const submitForm = (values) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const body = {
      userId: userDetails.userId,
      oldPassword: values.old_password,
      newPassword: values.new_password,
      hardReset: false
    };
    changePassword(body)
      .then((result) => {
        console.log(result, "result");
        reset()
        setChangePasswordRes({
          message: "Password Updated Successfully",
          color: "green",
        });
        showAlert("success", "Password Updated Successfully");
      })
      .catch((error) => {
        const errorRes = error.response;
        console.log(errorRes, "errorReserrorReserrorRes");
        setChangePasswordRes({
          message: errorRes.data?.message
            ? errorRes.data?.message
            : "Something went wrong",
          color: "red",
        });
        // showAlert(
        //   "error",
        //   errorRes.data?.message
        //     ? errorRes.data?.message
        //     : "Something went wrong"
        // );
      });
  };

  const new_password = watch("new_password");

  const ValidatePassword = (value) => {
    if (!value && !new_password) return true;
    return value == new_password;
  };
  return (
    <Fragment>
      <Breadcrumbs
        parent="Configuration"
        subParent="Change Password"
        mainTitle="Reset Password"
      />
      <Container fluid={true}>
        <Row>
          <Col lg="4">
            <Form
              className="change-password"
              onSubmit={handleSubmit(submitForm)}
            >
              <FormGroup className="position-relative">
                <Label className="col-form-label">{CurrentPassword}</Label>
                <input
                  className="form-control"
                  {...register("old_password", {
                    required: {
                      value: true,
                      message: "Current Password is required",
                    },
                  })}
                  type={toggleOldPassword ? "text" : "password"}
                />
                <div
                  className="show-hide"
                  onClick={() => setToggleOldPassword(!toggleOldPassword)}
                >
                  <span className={toggleOldPassword ? "" : "show"}></span>
                </div>
                <span style={{ color: "red" }}>
                  {errors?.old_password?.message}
                </span>
              </FormGroup>
              <FormGroup className="position-relative">
                <Label className="col-form-label">{NewPassword}</Label>
                <input
                  className="form-control"
                  {...register("new_password", {
                    required: {
                      value: true,
                      message: "New Password is required",
                    },
                    minLength: {
                      value: 5,
                      message: "Password cannot be less than 5 characters",
                    },
                  })}
                  type={toggleNewPassword ? "text" : "password"}
                  required=""
                />
                <div
                  className="show-hide"
                  onClick={() => setToggleNewPassword(!toggleNewPassword)}
                >
                  <span className={toggleNewPassword ? "" : "show"}></span>
                </div>
                <span style={{ color: "red" }}>
                  {errors?.new_password?.message}
                </span>
              </FormGroup>
              <FormGroup className="position-relative">
                <Label className="col-form-label">{ConfirmPassword}</Label>
                <input
                  className="form-control"
                  {...register("confirm_password", {
                    required: {
                      value: true,
                      message: "Confirm Password is required",
                    },
                    validate: (value) =>
                      ValidatePassword(value) || "Passwords do not match",
                  })}
                  type={toggleConfirmPassword ? "text" : "password"}
                  required=""
                />

                <div
                  className="show-hide"
                  onClick={() =>
                    setToggleConfirmPassword(!toggleConfirmPassword)
                  }
                >
                  <span className={toggleConfirmPassword ? "" : "show"}></span>
                </div>
                <span style={{ color: "red" }}>
                  {errors?.confirm_password?.message}
                </span>
              </FormGroup>
              {changePasswordRes.message ? (
                <span style={{ color: changePasswordRes.color }}>
                  {changePasswordRes.message}
                </span>
              ) : (
                ""
              )}
              <div className="position-relative form-group mb-0">
                <Btn
                  attrBtn={{
                    color: "primary",
                    className: "d-block w-100 mt-2",
                    disabled: loading ? loading : loading,
                  }}
                >
                  {loading ? "LOADING..." : UpdatePassword}
                </Btn>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ChangePassword;
